exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._57i0lvZiMpoeN2Ue3CPO_ {\n  position: relative;\n  padding: 8px 16px 6px 32px;\n  line-height: 1;\n  font-weight: 400;\n}\n._57i0lvZiMpoeN2Ue3CPO_ p {\n  margin: 0;\n  margin-bottom: 2px;\n}\n._57i0lvZiMpoeN2Ue3CPO_ ._3AWoVYJF4RQyHW7e_yJBeR {\n  font-size: 1.45rem;\n  font-weight: 500;\n}\n._57i0lvZiMpoeN2Ue3CPO_ .Tq1Mc5ykqqiJefNnO5Ohu {\n  color: #8993a4;\n  font-size: 1.18rem;\n}\n", ""]);
// Exports
exports.locals = {
	"base": "_57i0lvZiMpoeN2Ue3CPO_",
	"application": "_3AWoVYJF4RQyHW7e_yJBeR",
	"project": "Tq1Mc5ykqqiJefNnO5Ohu"
};